import tourLayers from "@/assets/tour/layers.jpg";
import tourDashboard from "@/assets/tour/dashboard.jpg";
import tourPlan from "@/assets/tour/plan.jpg";
import tourWizard from "@/assets/tour/wizard.jpg";
import tourTrack from "@/assets/tour/track.jpg";
import tourPeople from "@/assets/tour/people.jpg";
import tourCommunicate from "@/assets/tour/communicate.jpg";
import tourLibrary from "@/assets/tour/library.jpg";
import tourPmo from "@/assets/tour/pmo.jpg";
import tourMaestro from "@/assets/tour/maestro.jpg";
import tourPortfolio from "@/assets/tour/portfolio.jpg";

export const TOUR_SHOTS = {
  layers: [tourLayers, "The layer toggle — Project · Portfolio · PMO"],
  dashboard: [tourDashboard, "Your dashboard — week, health & automation"],
  plan: [tourPlan, "Plan menu — Visual Map of a live project"],
  wizard: [tourWizard, "Plan Wizard — one date in, a full plan out"],
  track: [tourTrack, "Track menu — the Status Report Builder"],
  people: [tourPeople, "People — Resource Cards in action"],
  communicate: [tourCommunicate, "Communicate — the Orchestra Pit"],
  library: [tourLibrary, "Library — templates & reusable knowledge"],
  pmo: [tourPmo, "PMO layer — your knowledge base"],
  maestro: [tourMaestro, "Maestro — AI plan drafting"],
  portfolio: [tourPortfolio, "Portfolio layer — executive rollups"],
};

export const TOUR_ORDER = ["layers", "dashboard", "plan", "wizard", "track", "people", "communicate", "library", "pmo", "maestro", "portfolio"];
